import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3angyj4q6y: FaireBrandEntity = {
  token: "b_3angyj4q6y",
  type: "brand",
  name: "Sightglass Coffee Roasters",
  avatarUrl:
    "https://cdn.faire.com/fastly/d1d13e58442204b5b7d6edc24f1001d6f2546db751a5b6bf71442f3f79020e79.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/675cf7d084c90a0b10e50dc73897bb9f1d9a3e6317b73ba0aaed95fa7d416f19.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d1d13e58442204b5b7d6edc24f1001d6f2546db751a5b6bf71442f3f79020e79.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/675cf7d084c90a0b10e50dc73897bb9f1d9a3e6317b73ba0aaed95fa7d416f19.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 17,
  isInsider: true,
  description:
    "Sightglass began as an aspiration to source, produce, and share distinctive coffees. \n\nIn 2009, we began with a small, rickety service-cart in San Francisco’s SoMa district. Equipped with a few Chemex pots and a leaky espresso machine, we served coffee to the rough-and-ready neighborhood behind a roll-up door in a sturdy 1914 built warehouse. Two years and many coffees later, the entirety of our the warehouse would become our first production roastery, a community gathering space, and our company headquarters. \n\nTen years and about a million cups of coffee later, we opened the doors of our Los Angeles roastery in West Hollywood, with a full-service restaurant, bakery and pastry program, as well as a rotation of highly curated specialty goods.\n\nOur company takes its name from the sightglass viewing window on our vintage PROBAT coffee roaster which exposes the delicate art of roasting coffee. We believe that knowing the story behind your coffee—where it was grown, how it was processed, and who handled it along the way—creates a powerful story in each cup.\n\nUltimately, we strive to deliver the highest quality possible in every aspect of our business, whether that means sourcing the beautiful coffee, employing diverse and unique talent, and living through sustainable practices.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:40.917Z",
    importedBy: "entity-db-cli",
  },
};
